import type { AutocompleteResponse, LoopSearchProductResults } from '../models/models';

import { useSearchStateContext } from '../contexts/searchStateContext';

export const useProductSearchStateContext = () => {
    const x = useSearchStateContext<[LoopSearchProductResults, AutocompleteResponse]>();
    const mapped = {
        ...x,
        result: x?.result?.[0],
        autocompleteResult: x?.result?.[1],
        queryUsed: x?.result?.[0]?.queryUsed || x?.query,
    };
    return mapped;
};
